import { LiveStatus } from '@core/types';
import { usePlatformStatus, WarningOutlined } from '@core/ui';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const ConnectionOfflineOverlay = ({ liveStatus }: { liveStatus: LiveStatus }) => {
    const { t } = useTranslation();
    const [wasConnected, setWasConnected] = useState<boolean>(false);
    const platformStatus = usePlatformStatus();

    useEffect(() => {
        if (liveStatus === LiveStatus.Live || liveStatus === LiveStatus.Paused) {
            setWasConnected(true);
        }
    }, [liveStatus]);

    if (liveStatus === LiveStatus.Live || liveStatus === LiveStatus.Paused) {
        return null;
    }

    // The cluster is behind the gateway's maintenance page: say so instead of "connecting", and
    // keep the SignalR retry loop running underneath; it is what brings the viewer back on recovery.
    const inMaintenance = platformStatus.kind === 'gateway-maintenance';

    return (
        <div className={`relative col-start-1 row-start-1 -col-end-1 -row-end-1 bg-linear-to-b from-primary/95 to-primary/75 flex justify-center z-50`}>
            <div className="absolute flex items-center justify-center h-full">
                <div className="relative max-w-9/10 bg-white rounded-md mx-auto px-5 py-3" data-testid={inMaintenance ? 'maintenance-gateway' : undefined}>
                    {inMaintenance && (
                        <>
                            <WarningOutlined classNames="size-10 fill-warning mb-2" />
                            <p className="text-2xl md:text-3xl xl:text-4xl mb-2">{t('Maintenance.Gateway.Title')}</p>
                            <p className="mb-4">{t('Maintenance.Gateway.Body')}</p>
                        </>
                    )}
                    {!inMaintenance && wasConnected && (
                        <>
                            <WarningOutlined classNames="size-10 fill-warning mb-2" />
                            <p className="text-2xl md:text-3xl xl:text-4xl mb-4">{t('Viewer.Message.ConnectionLost')}</p>
                        </>
                    )}
                    {!inMaintenance && !wasConnected && <p className="text-2xl md:text-3xl xl:text-4xl mb-4">{t('Viewer.Message.ConnectionConnecting')}</p>}
                </div>
            </div>
        </div>
    );
};
